module.exports = __webpack_public_path__ + "static/media/LightCloud.7ba2e93e.png";